// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field {
  display: flex;
  flex-direction: column;
  width: -moz-fit-content;
  width: fit-content;
}

.field-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

form {
  margin-bottom: 2rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 2rem;
}

.groups-field {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.groups-field .group-field {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, auto));
  gap: 1rem;
}
.groups-field button {
  margin-top: 1rem;
  width: -moz-fit-content;
  width: fit-content;
}

.translations {
  margin: 2rem 0;
}

p-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  margin-top: 2rem;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/contact/contact-edit/contact-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,6DAAA;EACA,SAAA;AACR;AAEI;EACI,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAGA,wjEAAwjE","sourcesContent":[".contact-details {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n}\n\n.field-group {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: stretch;\n}\n\nform {\n    margin-bottom: 2rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.groups-field {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .group-field {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(18rem, auto));\n        gap: 1rem;\n    }\n\n    button {\n        margin-top: 1rem;\n        width: fit-content;\n    }\n}\n\n.translations {\n    margin: 2rem 0;\n}\n\np-footer {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
